// extracted by mini-css-extract-plugin
module.exports = {"button":"C_bY","button__primary":"C_bZ","button__red":"C_b0","button__secondary":"C_b1","button__secondary__white":"C_b2","button__tertiary":"C_b3"};